const PARTNER_SLOT_LABEL_RE = /^(.*) - Partner \d+$/
const PARTNER_KEY_RE = /_partner_(\d+)$/

export function resolvePartnerLineLabel(
  label: string,
  lineKey: string,
  partnerLabels: Record<string, string> | null | undefined,
): string {
  if (!partnerLabels) {
    return label
  }
  const keyMatch = PARTNER_KEY_RE.exec(lineKey)
  if (!keyMatch) {
    return label
  }
  const partnerName = partnerLabels[`partner_${keyMatch[1]}`]
  if (!partnerName) {
    return label
  }
  const labelMatch = PARTNER_SLOT_LABEL_RE.exec(label)
  if (!labelMatch) {
    return label
  }
  return `${labelMatch[1]} - ${partnerName}`
}
